import React, { PropsWithChildren, ReactNode, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { classNames, useIsMounted } from "@ct-react/core";
import { buttonsTranslations } from "../../../i18n/sharable-defs";
import Chevron_down from "../../../../assets/svg/chevron-down-solid.svg";
import "./search-bar.scss";

type SearchBarItemType = PropsWithChildren & {
  className?: string;
  value?: any,
  title: ReactNode;
  resume: (value: any) => ReactNode;
  fallback: ReactNode;
  closeOnSelect?: boolean;
  withActions?: boolean;
  onReset?: () => void;
}

const SearchBarItem = (
  {
    className,
    children,
    value,
    title,
    resume,
    fallback,
    closeOnSelect = false,
    withActions = true,
    onReset = () => void 0
  }: SearchBarItemType) => {

  const isMounted = useIsMounted();
  const intl = useIntl();
  const wrapperClasses = classNames("search-bar-item", className);
  const activeRef = useRef<HTMLInputElement>(null);

  const onDisplay = (state: boolean = true) => {
    if (!activeRef.current) return;
    activeRef.current.checked = state;
  };

  const onReverseDisplay = () => {
    if (!activeRef.current) return;
    activeRef.current.checked = !activeRef.current.checked;
  };

  useEffect(() => {
    (isMounted && !!value && closeOnSelect) && onDisplay(false);
  }, [ value ]);

  return (
    <div className={wrapperClasses}
         onMouseEnter={() => onDisplay()}
         onMouseLeave={() => onDisplay(false)}>

      <input type="checkbox" ref={activeRef} className="activator" />

      <div className="resume"
           onTouchEnd={() => onReverseDisplay()}>
        {!!value && <span className="value">{resume(value)}</span>}
        <span className="title">{fallback}</span>
        <Chevron_down />
      </div>

      <div className="selector">
        <div className="inner-content">
          <h4>{title}</h4>
          <div className="wrapper">{children}</div>
          {withActions &&
            <div className="actions">
              <button type="button" className="btn" onClick={() => onReset()}>
                {intl.formatMessage(buttonsTranslations.reset)}
              </button>
              <button type="button" className="btn-red close" onClick={() => onDisplay(false)}>
                {intl.formatMessage(buttonsTranslations.close)}
              </button>
            </div>
          }
        </div>
      </div>

    </div>);

}

export default SearchBarItem;
